import { use } from 'react'
import { RBACContext } from '@/components/rbac/context'

export const useRBAC = () => {
  const { rbac, idCompanies, totalServices, rolesInCompany } = use(RBACContext)

  return {
    rbac,
    idCompanies,
    totalServices,
    rolesInCompany,
  }
}
